/**
 * TabPanel - Common component for tab content
 *
 * Wrapper component for tab content that handles visibility
 * based on the current tab index.
 */

import React from 'react';
import { Box } from '@mui/material';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children - Tab content
 * @param {number} props.value - Currently active tab index
 * @param {number} props.index - This tab's index
 * @param {number} [props.pt=3] - Padding top (MUI spacing units)
 */
export function TabPanel({ children, value, index, pt = 3, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && <Box sx={{ pt }}>{children}</Box>}
        </div>
    );
}

export default TabPanel;
